// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const zarude: PokeData = {
  "id": 893,
  "name": "zarude",
  "height": 18,
  "weight": 700,
  "base_experience": 300,
  "types": [
    PokeType.DARK,
    PokeType.GRASS
  ],
  "api_moves": [
    "scratch",
    "bind",
    "vine-whip",
    "thrash",
    "leer",
    "bite",
    "growth",
    "fury-swipes",
    "scary-face",
    "swagger",
    "synthesis",
    "hammer-arm",
    "u-turn",
    "energy-ball",
    "power-whip",
    "grass-knot",
    "jungle-healing"
  ],
  "moves": [
    "scratch",
    "vine-whip",
    "leer",
    "bite",
    "scary-face",
    "synthesis",
    "energy-ball",
    "power-whip",
    "flatter",
    "flower-rush",
    "pursuit",
    "dark-bargain",
    "solar-beam"
  ],
  "evolution_chain": {
    "id": 471,
    "item": null,
    "species": [
      {
        "name": "zarude",
        "order": 893,
        "types": [
          PokeType.DARK,
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 125,
    "speed": 128,
    "ability_power": 147
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
